import type { ComponentPropsWithoutRef, FormEvent } from 'react';

export const InputWithCustomValidationFeedback = ({
    customValidationFeedback,
    ...rest
}: ComponentPropsWithoutRef<'input'> & { customValidationFeedback: string }) => {
    return (
        <input
            {...rest}
            onInvalid={(e: FormEvent<HTMLInputElement>) => {
                const target = e.target as HTMLInputElement;
                //Let the default message occur for empty fields.
                if (!target.value.trim()) {
                    return;
                }
                if (customValidationFeedback) {
                    target.setCustomValidity(customValidationFeedback);
                }
            }}
            onInput={(e: FormEvent<HTMLInputElement>) => {
                (e.target as HTMLInputElement).setCustomValidity('');
            }}
        />
    );
};
